<template>
  <div class="total-cost">
    <img loading="lazy" sizes="100%, 100%" :src="coinSrc" alt="Total cost"
         title="Total cost">
    <span class="coin-total">{{formatPrice(tc)}}</span>
  </div>
</template>

<script>
  export default {
    name: "EquipmentCost",
    props: {
      equipment: {
        type: Object,
        required: true,
      }
    },
    data() {
      return {
        itemPrices: {},
      }
    },
    computed: {
      coinSrc: function () {
        if (this.tc >= 10000)
          return "/static/images/icons/coins/10000.png";

        if (this.tc >= 1000)
          return "/static/images/icons/coins/1000.png";

        if (this.tc >= 250)
          return "/static/images/icons/coins/250.png";

        if (this.tc >= 100)
          return "/static/images/icons/coins/100.png";

        if (this.tc >= 25)
          return "/static/images/icons/coins/25.png";

        if (this.tc >= 5)
          return "/static/images/icons/coins/5.png";

        if (this.tc >= 4)
          return "/static/images/icons/coins/4.png";

        if (this.tc >= 3)
          return "/static/images/icons/coins/3.png";

        if (this.tc >= 2)
          return "/static/images/icons/coins/2.png";

        return "/static/images/icons/coins/1.png"
      },
      tc: function () {
        return this.calcTotal();
      },
      total_cost: function () {
        let total = 0;

        for (let i = 0; i < this.equipmentIds.length; i++) {
          // console.log(`cacheCost ${i}`, [total, this.equipmentIds[i], this.cachedItemPrice(this.equipmentIds[i])]);
          total = total + this.cachedItemPrice(this.equipmentIds[i]);
        }

        return total;
      },

      equipmentIds: function () {
        return Object.keys(this.equipment).map((k) => {
          if (this.itemPrices[this.equipment[k].id] === undefined)
            this.getItemPrice(this.equipment[k].id);

          return this.equipment[k].id
        });
      }
    },
    methods: {
      getItemPrice: function (id) {
        if (id === 0)
          return;

        const uri = `${process.env.API_ADDR}/items/cost/${id}`;
        this.$http.get(uri).then((resp) => {
          if (resp.data === "" || resp.status !== 200) {
            return;
          }
          console.log(`new: item price found: (${id})`, resp.data);

          localStorage.setItem(`osrs:compare:item:${id}`, resp.data.overall_average);
          this.$set(this.itemPrices, id, resp.data.overall_average);
        })
      },

      calcTotal: function () {
        let total = 0;
        for (let [key, item] of Object.entries(this.equipment)) {
          if (item.id === 0)
            continue;

          if (!item.tradeable_on_ge) {
            total += item.cost;
            continue;
          }

          let price = this.cachedItemPrice(item.id);
          // console.debug(`calcTotal`, [item, price]);

          if (price === 0) {
            this.getItemPrice(item.id)
          }

          total += price
        }


        return total;
      },

      loadCachedItem: function (item) {
        const cachePrice = localStorage.getItem(`osrs:compare:item:${item.id}`);
        if (cachePrice !== null) {
          console.debug(`cache: item price found: ${item.name} (${item.id})`, cachePrice);
          this.$set(this.itemPrices, item.id, JSON.parse(cachePrice));
        }

        return this.itemPrices[item.id]
      },

      cachedItemPrice: function (id) {
        if (id in this.itemPrices) {
          return this.itemPrices[id]
        }
        return 0;
      },

      loadEquipmentPrices: function () {
        console.log('loading equip prices', this.equipment);
        for (let [key, item] of Object.entries(this.equipment)) {
          if (item.id in this.itemPrices)
            continue;

          const cachePrice = this.loadCachedItem(item);
          if (cachePrice === 0)
            this.getItemPrice(item.id)
        }
      },

      formatPrice(value) {
        let formatter = new Intl.NumberFormat('en-US', {
          style: 'decimal',
          minimumFractionDigits: 0
        });
        return formatter.format(value);
      }
    },
    mounted() {
      this.loadEquipmentPrices();
    }
  }
</script>

<style scoped>
  .coin-total {
    font-family: 'RuneScape UF', sans-serif;
    text-shadow: 0.1rem 0.1rem black;
    font-size: 1.4rem;
    letter-spacing: 0.1rem;
    color: #F5FC00;
  }
</style>



// WEBPACK FOOTER //
// src/components/gear-selector/EquipmentCost.vue